<template>
    <div>
        <div class="container flex flex-col items-center py-10">
            <div class="w-10/12 flex flex-wrap items-center justify-center">
                <div class="w-full md:w-auto mb-4 md:mb-0 md:mr-8">
                    <h1 class="text-xl lg:text-2xl text-dark-200 text-center md:text-left border-light-300">Compare</h1>
                </div>
                <div class="w-full md:w-5/12 lg:w-4/12 xl:w-3/12">
                    <div class="relative w-full px-1">
                        <select v-model="questionnaire" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400 px-4 py-2 pr-8 rounded leading-tight focus:outline-none">
                            <option v-for="(label, name) of questionnairesList"
                                    :value="name"
                                    :key="name">{{ label }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 mr-3 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-10/12 md:w-full lg:w-full xl:w-10/12 flex flex-wrap items-center justify-center">
                <div class="flex flex-wrap w-full md:w-5/12">
                    <div class="relative w-full md:w-6/12 mt-8 px-1">
                        <select v-model="firstChoice" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400 px-4 py-2 pr-8 rounded leading-tight focus:outline-none">
                            <option>Country</option>
                            <option>Person</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 mr-3 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    <div v-if="firstChoice === 'Country'" class="relative w-full md:w-6/12 mt-8 px-1">
                        <select v-model="country[0]" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400 px-4 py-2 pr-8 rounded leading-tight focus:outline-none">
                            <option v-for="c of countriesForSelectedQuestionnaire"
                                    :value="c"
                            >{{ c }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 mr-3 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    <div v-else class="relative w-full md:w-6/12 mt-8 px-1">
                        <input v-model="firstToken"
                               type="text" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400  py-2 px-10 pr-4 rounded leading-tight focus:outline-none"/>
                        <div class="pointer-events-none absolute inset-y-0 left-0 ml-4 flex items-center px-2 text-primary-100">
                            <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z"/></svg>
                        </div>
                    </div>
                </div>

                <div class="w-full md:w-1/12 mt-8 md:py-0">
                    <h1 class="text-xl lg:text-2xl text-dark-200 text-center border-light-300">VS</h1>
                </div>

                <div class="flex flex-wrap w-full md:w-5/12">
                    <div class="relative w-full md:w-6/12 mt-8 px-1">
                        <select v-model="lastChoice" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400 px-4 py-2 pr-8 rounded leading-tight focus:outline-none">
                            <option>Country</option>
                            <option>Person</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 mr-3 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    <div v-if="lastChoice === 'Country'" class="relative w-full md:w-6/12 mt-8 px-1">
                        <select v-model="country[1]" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400 px-4 py-2 pr-8 rounded leading-tight focus:outline-none">
                            <option v-for="c of countriesForSelectedQuestionnaire"
                                    :value="c"
                            >{{ c }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 mr-3 flex items-center px-2 text-gray-700">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                    </div>
                    <div v-else class="relative w-full md:w-6/12 mt-8 px-1">
                        <input v-model="lastToken"
                               type="text" class="block appearance-none w-full bg-white border border-2 border-light-300 hover:border-gray-400  py-2 px-10 pr-4 rounded leading-tight focus:outline-none"/>
                        <div class="pointer-events-none absolute inset-y-0 left-0 ml-4 flex items-center px-2 text-primary-100">
                            <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z"/></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="w-11/12 mx-auto flex justify-center items-center py-64">
            <loader/>
        </div>

        <template v-else>

            <template v-if="!errorMessageFirst">
                <compare-person
                    v-if="firstChoice === 'Person' && person[0].token"
                    :person="person[0]"
                    :competencies="competencies"
                />

                <compare-country
                    v-if="firstChoice === 'Country' && country[0]"
                    :country="country[0]"
                    :scores="averageCountryScores(country[0])"
                    :questionnaire="questionnaireName"
                />
            </template>

            <div v-else class="flex flex-col flex-1 justify-center py-12">
                <h3 class="relative text-xl sm:text-2xl font-bold text-center">{{ errorMessageFirst }}</h3>
            </div>

            <div class="p-2 md:p-4 my-2 bg-primary-100 text-xl md:text-2xl font-bold text-center text-white">VS</div>

            <template v-if="!errorMessageLast">
                <compare-country
                    v-if="lastChoice === 'Country' && country[1]"
                    :country="country[1]"
                    :scores="averageCountryScores(country[1])"
                    :questionnaire="questionnaireName"
                />

                <compare-person
                    v-if="lastChoice === 'Person' && person[1].token"
                    :person="person[1]"
                    :competencies="competencies"
                />
            </template>
            <div v-else class="flex flex-col flex-1 justify-center py-12">
                <h3 class="relative text-xl sm:text-2xl font-bold text-center">{{ errorMessageLast }}</h3>
            </div>

        </template>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { getAllCompetenciesAndFeedback, getScoreAndFeedback } from '../../questions/score-calculator';
    import Loader from '../shared/Loader';
    import ComparePerson from '../compare/ComparePerson';
    import CompareCountry from '../compare/CompareCountry';

    export default {
        components: {
            Loader,
            ComparePerson,
            CompareCountry,
        },
        data() {
            return {
                loading: true,
                errorMessageFirst: null,
                errorMessageLast: null,
                countries: [],
                country: [null, null],
                person: [
                    {
                        name: null,
                        country: null,
                        token: null,
                        session: null,
                        sessions: [],
                    },
                    {
                        name: null,
                        country: null,
                        token: null,
                        session: null,
                        sessions: [],
                    }
                ],
                questionnaire: null,
                competencies: {},
                average: {},
                firstChoice: null,
                lastChoice: null,
                firstToken: null,
                lastToken: null,
                userDataTimer: null,
            }
        },
        computed: {
            questionnairesList() {
                return {
                    startup: 'Start-up Stage',
                    validate: 'Validate Stage',
                    scale: 'Prepare-to-Scale Stage'
                }
            },
            questionnaireName() {
                return this.questionnairesList[this.questionnaire];
            },
            countriesForSelectedQuestionnaire() {
                return this.countries.filter(country => {
                    return Object.keys(this.average[country][this.questionnaire]).length;
                });
            }
        },
        watch: {
            country() {
                this.updateUrlFilters();
            },
            firstToken(token) {
                this.getUserData(token, 0);
            },
            lastToken(token) {
                this.getUserData(token, 1);
            },
            questionnaire(questionnaire) {
                this.errorMessageFirst = null;
                this.errorMessageLast = null;

                let personDataCounter = 0;
                let numberOfPeople = [this.firstChoice, this.lastChoice].filter(section => section === 'Person').length;

                [this.firstChoice, this.lastChoice].forEach((section, index) => {
                    if (section === 'Person' && this.person[index].token) {
                        this.loading = true;
                        personDataCounter++;

                        const token = this.person[index].token;

                        this.person[index].session = null;
                        this.person[index].sessions = [];

                        getScoreAndFeedback(token, questionnaire).then(value => {
                            this.handleUserData(value, index, token);
                            if (personDataCounter === numberOfPeople) {
                                this.loading = false;
                            }
                        });
                    }
                });

                this.updateUrlFilters();
            }
        },
        methods: {
            averageCountryScores(country) {
                if (!country) {
                    return [];
                }

                const averageForCountry = this.average[country] || [];
                const averageForQuestionnaire = averageForCountry[this.questionnaire] || null;

                if (!averageForQuestionnaire) {
                    return [];
                }

                const averageScores = [];

                Object.keys(averageForQuestionnaire).forEach(comp => {
                    averageScores.push({
                        score: averageForQuestionnaire[comp],
                        competency: this.$options.filters.trans(this.competencies[comp].name),
                    })
                });

                return averageScores;
            },
            handleUserData(value, index, token) {
                const errorMessage = index === 0 ? 'errorMessageFirst' : 'errorMessageLast';

                if (value.data.error) {
                    this[errorMessage] = value.data.error;
                    return this.loading = false;
                } else {
                    this[errorMessage] = null;
                }

                const sessions = Object.keys(value.data.sessions).sort((a, b) => Number(b) - Number(a));

                this.person[index].name = value.data.name;
                this.person[index].country = value.data.country;
                this.person[index].token = token;
                this.person[index].sessions = value.data.sessions;

                if (!this.person[index].session) {
                    this.person[index].session = sessions.slice(-1).pop();
                }

                index === 0 ? (this.firstToken = token) : (this.lastToken = token);

                this.updateUrlFilters();
            },
            getUserData(value, index) {
                this.loading = true;

                const tokenRegex = new RegExp(/[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}/i);
                const tokenMatching = value.match(tokenRegex);
                if (!tokenMatching) {
                    return this.loading = false;
                }

                const token = tokenMatching[0];
                const questionnaire = this.questionnaire;

                if (this.userDataTimer) {
                    clearTimeout(this.userDataTimer);
                }

                this.userDataTimer = setTimeout(() => {
                    getScoreAndFeedback(token, questionnaire).then(value => {
                        this.handleUserData(value, index, token);

                        this.updateUrlFilters();

                        this.loading = false;
                    });
                }, 500);
            },
            updateUrlFilters() {
                let params = {};
                if (this.firstChoice === 'Person') {
                    params.token = this.person[0].token || this.firstToken;
                }
                if (this.firstChoice === 'Country') {
                    params.country = this.country[0];
                }
                if (this.lastChoice === 'Person') {
                    params.token = params.token ? [params.token, this.person[1].token || this.lastToken] : this.person[1].token || this.lastToken;
                }
                if (this.lastChoice === 'Country') {
                    params.country = params.country ? [params.country, this.country[1]] : this.country[1];
                }
                if (this.person[0].session) {
                    params.s1 = this.person[0].session;
                }
                if (this.person[1].session) {
                    params.s2 = this.person[1].session;
                }

                params.q = this.questionnaire;
                this.$router.replace({query: params}).catch(err => {});
            }
        },
        mounted() {
            this.questionnaire = this.$route.query.q || 'startup';
            let countries = this.$route.query.country;
            let tokens = this.$route.query.token;
            this.person[0].session = this.$route.query.s1 || null;
            this.person[1].session = this.$route.query.s2 || null;

            if (!tokens) {
                this.firstChoice = 'Country';
                this.lastChoice = 'Country';
            } else if (Array.isArray(tokens)) {
                tokens = tokens.slice(0, 2);
                this.firstChoice = 'Person';
                this.lastChoice = 'Person';
                this.firstToken = tokens[0];
                this.lastToken = tokens[1];
            } else {
                tokens = [tokens];
                this.firstChoice = 'Person';
                this.lastChoice = 'Country';
                this.firstToken = tokens[0];
            }

            if (Array.isArray(countries)) {
                countries = countries.slice(0, 2);
                this.country[0] = countries[0];
                this.country[1] = countries[1];
            } else if (countries) {
                this.country[1] = countries;
            }

            Promise.all([
                db.collection('average-scores').doc('data').get(),
                getAllCompetenciesAndFeedback()
            ]).then(values => {
                this.average = values[0].data();
                this.countries = Object.keys(this.average);
                this.competencies = values[1].data[this.questionnaire].competencies;

                if (!tokens) {
                    this.loading = false;
                }
            });

            if (tokens) {
                const peopleDataPromises = [];
                tokens.forEach(token => peopleDataPromises.push(getScoreAndFeedback(token, this.questionnaire)));

                Promise.all(peopleDataPromises).then(values => {
                    values.forEach((value, index) => this.handleUserData(value, index, tokens[index]));

                    if (!this.country[1] && tokens.length === 1) {
                        this.country[1] = this.person[0].country
                    }

                    this.loading = false;
                });
            }
        }
    }
</script>
